var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"display-1"},[_vm._v(" 404 ")]),_c('h2',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.$t('pages.page404.text'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }